import React, { FC } from 'react'

import { ListingStatus } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { labelByListingStatus } from '@new/__global/constants/listingStatus'

import { FiltersSharedProps } from './Filters.types'

interface ListingStatusFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
}

export const ListingStatusFilter: FC<ListingStatusFilterProps> = props => {
  const listingStatusOptions = Object.values(ListingStatus).map(listingStatus => ({
    value: listingStatus,
    hasFullWidth: true,
    label: labelByListingStatus[listingStatus],
  }))

  return <CheckboxBasedFilter title="Listing Status" options={listingStatusOptions} {...props} />
}
